<template>
  <div class="search-title">
    <router-link :to="returnRoute" class="icon-arrow-left"></router-link>
    <h1 class="title-with-icon mobile-top-icon">
      <span class="icon-search" :class="brandColor"></span>
      {{ $t("i_search_a_machine") }}
      <span class="subtitle" v-if="selectedCategory">{{ selectedCategory.label }}</span>
    </h1>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
name: "ResultsTitle",
  computed: {
    ...mapState({
      selectedCategory: state => state.searchMachines.category,
      marketFilter: state => state.searchMachines.marketFilter
    }),

    returnRoute() {
      if(this.marketFilter) return {name: 'search-markets'};
      else return {path: '/search'}
    }
  }

}
</script>

<style scoped>

</style>